
















import { Vue, Component, Prop } from 'vue-property-decorator';
import CurrencyService from '@/domain/currency/service/currency.service';
import Currency from '@/domain/currency/entity/currency.entity';

@Component
export default class CurrencyConvertComponent extends Vue {
  @Prop({
    type: String,
  }) label!: string;

  @Prop({
    type: String,
  }) currencySelected!: string;

  @Prop({
    type: Boolean,
    default: false,
  }) disabled!: boolean;

  currencyList: Currency[] = [];

  created() {
    this.getCurrency();
  }

  getCurrency() {
    CurrencyService.getAllCurrencies().then((response) => {
      this.currencyList = Currency.ofList(response);
    })
  }

  updateCurrencyValue() {
    this.$emit('update', this.currencySelected);
  }
}
